module.exports = __webpack_public_path__ + "static/media/level3-1.bb188fdb.mp3";